export const LOAD_PREFERRED_SITE_LIST = 'booking/LOAD_PREFERRED_SITE_LIST';
export const LOAD_PREFERRED_SITE_LIST_SUCCESS =
  'booking/LOAD_PREFERRED_SITE_LIST_SUCCESS';
export const LOAD_PREFERRED_SITE_LIST_ERROR =
  'booking/LOAD_PREFERRED_SITE_LIST_ERROR';
export const RESET_PREFERRED_SITE_LIST = 'RESET_PREFERRED_SITE_LIST';
export const LOCATIONS = {
  WESTERN_AUSTRALIA: 'Western Australia',
  QUEENLAND: 'Queensland',
};
